import { ReactNode } from 'react';
import { Modal } from 'antd';
import './payease-modal.scss';

interface IPayEaseModalProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  subtitle?: ReactNode;
  width?: number;
  children: ReactNode;
}

export const PayEaseModal = ({ open, onClose, title, subtitle, width = 460, children }: IPayEaseModalProps) => (
  <Modal open={open} onCancel={onClose} footer={null} width={width} centered getContainer={false} title={title}>
    {subtitle && <p className="pe-modal__subtitle">{subtitle}</p>}
    {children}
  </Modal>
);
